import {FC} from 'react'
import BrandIcon from '../icons/BrandIcon'
import {Brand} from '../../brands/core/_models'

type Props = {
  brand?: Brand
}

const BrandCell: FC<Props> = ({brand}) => {
  if (!brand) {
    return <></>
  }

  return (
    <span title={brand.name}>
      <BrandIcon brand={brand} className="fs-1" />
    </span>
  )
}

export {BrandCell}
